import script from "./RestoreAccountView.vue?vue&type=script&lang=ts&setup=true"
export * from "./RestoreAccountView.vue?vue&type=script&lang=ts&setup=true"

import "./RestoreAccountView.vue?vue&type=style&index=0&id=bb15b738&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb15b738"]])

export default __exports__